import { GetStaticPropsContext } from 'next';

import { registerComponents } from '@/builder';
import { Locale } from '@/helpers/LangHelper';
import { createStaticPaths, createStaticProps } from '@/utils/Builder';

registerComponents();

export async function getStaticPaths() {
    return createStaticPaths(false, Locale.USA);
}

export async function getStaticProps({ params }: GetStaticPropsContext<any>) {
    const { business } = params;
    const usParams = {
        ...params,
        slug: [Locale.USA, business, 'access/guides'],
    };

    return createStaticProps({ params: usParams, includeUnpublished: false });
}

export { default } from '../../[...slug]';
